import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://techtools.backend.sofadigital.com/api";

export async function fetchTelecineMxGap(params = {}) {
  const response = await axios.get(
    `${BACKEND_URL}/telecine-mx-gap/`,
    {
      params,
    },
  );
  return response.data;
}
